export const TEHRAN_COORDINATES = [51.3890, 35.6892];
